import _debounce from 'lodash/debounce'

const MAX_STACK_SIZE = 20;

const debouncedPushUndoStack = _debounce((context, widget) => {
  context.commit('PUSH_UNDO_STACK', {
    payload: {
      widgetId: widget.id,
      widget: widget,
    },
    clearRedoStack: true,
  });
}, 400);


export default {
  namespaced: true,
  state: () => ({
    undoStack: [],
    redoStack: [],
    isUndoRedoInProgress: false,
  }),
  mutations: {
    SET_UNDO_REDO_IN_PROGRESS(state, value) {
      state.isUndoRedoInProgress = value;
    },
    PUSH_UNDO_STACK(state, { payload, clearRedoStack = true }) {
      state.undoStack.push(payload);
      if (state.undoStack.length > MAX_STACK_SIZE) {
        state.undoStack.shift(); // Remove the oldest state
      }
      if (clearRedoStack) {
        state.redoStack = [];
      }
    },
    PUSH_REDO_STACK(state, payload) {
      state.redoStack.push(payload);
    },
    POP_UNDO_STACK(state) {
      state.undoStack.pop();
    },
    POP_REDO_STACK(state) {
      state.redoStack.pop();
    },
    CLEAR_UNDO_STACK(state) {
      state.undoStack = [];
    },
    CLEAR_REDO_STACK(state) {
      state.redoStack = [];
    },
  },
  actions: {
    pushUndoStack(context, widget) {
      debouncedPushUndoStack(context, widget);
    },
    undo({ commit, dispatch, state, rootState }) {
      if (state.undoStack.length === 0 || state.isUndoRedoInProgress) return;
      commit('SET_UNDO_REDO_IN_PROGRESS', true);

      const lastIndex = state.undoStack.length - 1;
      const lastState = state.undoStack[lastIndex];

      const currentWidget = JSON.parse(
        JSON.stringify(
          rootState.campaign.widget.widgetItems[lastState.widgetId],
        ),
      );

      commit('PUSH_REDO_STACK', {
        widgetId: lastState.widgetId,
        widget: currentWidget,
      });

      dispatch('campaign/contentItem/clearTargetContentItem', null, { root: true });

      commit('campaign/widget/RESTORE_WIDGET_STATE', lastState.widget, { root: true });

      commit('POP_UNDO_STACK');
      commit('SET_UNDO_REDO_IN_PROGRESS', false);
    },
    redo({ commit, dispatch, state, rootState }) {
      if (state.redoStack.length === 0 || state.isUndoRedoInProgress) return;
      commit('SET_UNDO_REDO_IN_PROGRESS', true);

      const lastIndex = state.redoStack.length - 1;
      const nextState = state.redoStack[lastIndex];

      const currentWidget = JSON.parse(
        JSON.stringify(
          rootState.campaign.widget.widgetItems[nextState.widgetId],
        ),
      );

      // Push current state onto undo stack without clearing redo stack
      commit('PUSH_UNDO_STACK', {
        payload: {
          widgetId: nextState.widgetId,
          widget: currentWidget,
        },
        clearRedoStack: false, // Do not clear redo stack during redo
      });

      dispatch('campaign/contentItem/clearTargetContentItem', null, { root: true });

      commit('campaign/widget/RESTORE_WIDGET_STATE', nextState.widget, { root: true });

      commit('POP_REDO_STACK');
      commit('SET_UNDO_REDO_IN_PROGRESS', false);
    },
    clearStacks({ commit }) {
      commit('CLEAR_UNDO_STACK');
      commit('CLEAR_REDO_STACK');
    },
  },
  getters: {
    canUndo(state) {
      return state.undoStack.length > 0;
    },
    canRedo(state) {
      return state.redoStack.length > 0;
    },
  },
};
